import React from "react";
import image1 from "./images/image1.jpg";
import image2 from "./images/image2.jpg";
import image3 from "./images/image3.jpg";
import image4 from "./images/image4.jpeg";
import "./css/general.css";
import "./css/Home.css";
import { HashLink as Link } from "react-router-hash-link";

export default function NewYearLandingPage() {
  return (
    <>
      {/*section1-- welcome*/}
      <section className="u-clearfix u-grey-5 u-section-1" id="sec-2693">
        <div className="u-clearfix u-sheet u-sheet-1">
          <div className="u-palette-4-base u-shape u-shape-rectangle u-shape-1"></div>
          <div className="u-palette-2-base u-shape u-shape-rectangle u-shape-2"></div>
          <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-container-style u-group u-palette-2-base u-group-1">
            <div className="u-container-layout u-valign-top u-container-layout-1">
              <h1 className="u-text u-text-1"> Welcome to our</h1>
              <p className="u-text u-text-body-alt-color u-text-2">
                Busy woman’s guide to <br />
                building lasting resiliency{" "}
                <span style={{ fontSize: "1.5rem" }}>
                  <b>giveaway</b>
                </span>{" "}
                <br />
                and
                <span style={{ fontSize: "1.5rem" }}>
                  <b> community</b>
                </span>
                <br />
                <br />
              </p>
              <Link
                to="#section2"
                className="u-active-palette-2-light-3 u-btn u-button-style u-hover-palette-2-light-3 u-text-active-palette-2-base u-text-hover-palette-2-base u-text-palette-2-base u-white u-btn-1"
              >
                read more
              </Link>
            </div>
          </div>
          <img
            className="u-image u-image-1"
            src={image1}
            data-image-width="1080"
            data-image-height="1080"
            alt=" "
          />
        </div>
      </section>

      {/*section2-- hello ladies*/}
      <section className="u-clearfix u-grey-5 u-section-2" id="section2">
        <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-sheet-1">
          <div className="u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
            <div className="u-layout">
              <div className="u-layout-row">
                <div className="u-align-left u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                  <div className="u-container-layout u-valign-bottom u-container-layout-1">
                    <div className="u-palette-2-base u-shape u-shape-rectangle u-shape-1"></div>
                    <h2 className="u-text u-text-1">
                      <b>Hello ladies!</b>
                    </h2>
                    <p className="u-text u-text-2">
                      {" "}
                      Have you been dreaming of the day where you feel
                      energetic, vibrant, resilient, and are deeply
                      connected/reconnected to your authentic self?
                      <br />
                      <br />
                      Have you envisioned that you rebuild your confidence,
                      self-esteem, and you attract the same type of people and
                      situations into your life?
                      <br />
                      <br />
                      Wondering how to turn this into a reality during this time
                      when gyms and studios continue to open and close, making
                      it challenging to develop consistent habits and work-life
                      balance?
                      <br />
                    </p>
                  </div>
                </div>
                <div className="u-align-justify-xl u-container-style u-layout-cell u-size-30 u-layout-cell-2">
                  <div className="u-container-layout u-valign-top-sm u-container-layout-2">
                    <p className="u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xs u-custom-font u-heading-font u-text u-text-palette-2-base u-text-3">
                      <b> We have so​mething perfect for you…</b>
                    </p>
                    <p className="u-align-justify-lg u-align-justify-md u-align-justify-sm u-align-justify-xs u-text u-text-4">
                      {" "}
                      Subscribe to KellyKinetix for free!&nbsp;
                      <br />
                      Redeem your <b>1-month free</b> access to classes and be a
                      part of the email series curated just for your health
                      benefits.
                    </p>
                    <a
                      href="/WomensDayContest/ThankYou"
                      className="u-active-palette-4-base u-btn u-button-style u-hover-palette-4-base u-palette-2-base u-text-active-white u-text-body-alt-color u-text-hover-white u-btn-1"
                    >
                      Subscribe now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*section3-- don't miss the opportunity*/}
      <section className="u-clearfix u-image u-section-3" id="sec-e668">
        <div className="u-clearfix u-sheet u-sheet-1">
          <div className="u-clearfix u-layout-wrap u-layout-wrap-1">
            <div className="u-gutter-0 u-layout">
              <div className="u-layout-row">
                <div className="u-align-left u-container-style u-layout-cell u-left-cell u-size-30 u-layout-cell-1">
                  <div className="u-container-layout u-valign-top u-container-layout-1">
                    <img
                      className="u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-image u-image-1"
                      src={image3}
                      data-image-width="792"
                      data-image-height="792"
                      alt=" "
                    />
                  </div>
                </div>
                <div className="u-align-left u-container-style u-layout-cell u-right-cell u-size-30 u-layout-cell-2">
                  <div className="u-container-layout u-container-layout-2">
                    <h1 className="u-text u-text-palette-2-base u-text-1">
                      Don't miss this opportunity!
                    </h1>
                    <p className="u-text u-text-2">
                      {" "}
                      Access your newly vibrant, resilient and confident self
                      for 2022&nbsp;
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*section4-- what's in it*/}
      <section className="u-clearfix u-grey-5 u-section-4" id="carousel_d766">
        <div className="u-clearfix u-sheet u-sheet-1">
          <div className="u-clearfix u-expanded-width u-layout-wrap u-layout-wrap-1">
            <div className="u-layout">
              <div className="u-layout-row">
                <div className="u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                  <div className="u-container-layout u-valign-bottom u-container-layout-1">
                    <h2 className="u-align-left u-text u-text-palette-2-base u-text-1">
                      {" "}
                      What’s in it for you?
                    </h2>
                    <p className="u-align-justify u-text u-text-2">
                      {" "}
                      The skills I honed in my journey, in the last ten years,
                      from nursing to becoming a successful fitness and wellness
                      expert, will benefit busy women, like you, in providing
                      preventive and healing abilities, and boost your immune
                      system. <br />
                      <br />
                      So, why wait?&nbsp;
                    </p>
                  </div>
                </div>
                <div className="u-align-left u-container-style u-layout-cell u-size-30 u-layout-cell-2">
                  <div className="u-container-layout u-container-layout-2">
                    <div className="u-palette-2-base u-shape u-shape-circle u-shape-1"></div>
                    <h1 className="u-text u-text-palette-4-base u-text-3">
                      {" "}
                      Grab the deal before it is too late!
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*section5-- contest prizes*/}
      <section
        className="u-align-center u-clearfix u-grey-5 u-section-5"
        id="carousel_a068"
      >
        <div className="u-clearfix u-sheet u-sheet-1">
          <h2 className="u-text u-text-1">
            <b>Contest Prize</b>
          </h2>
          <p className="u-text u-text-grey-50 u-text-2">
            <b>
              Enter your email and fill in the questionnaire to enter the
              giveaway contest&nbsp;
            </b>
          </p>
          <div className="u-clearfix u-gutter-30 u-layout-wrap u-layout-wrap-1">
            <div className="u-layout">
              <div className="u-layout-row">
                <div className="u-align-left u-container-style u-layout-cell u-palette-3-base u-radius-50 u-right-cell u-shape-round u-size-30 u-layout-cell-1">
                  <div className="u-container-layout u-container-layout-1">
                    <h1 className="u-text u-text-3">
                      <b>GRAND PRIZE&nbsp;</b>
                      <br />
                    </h1>
                    <p className="u-text u-text-grey-50 u-text-4">
                      1 lucky winner
                    </p>
                    <div className="u-border-20 u-border-white u-expanded-width u-line u-line-horizontal u-line-1"></div>
                    <p className="u-text u-text-5">
                      {" "}
                      Includes:
                      <b>
                        <br />
                        <b>Free Health & Wellness Consultation</b>&nbsp;
                        <br />
                        <b>Free one-month access to the Deluxe Package</b>&nbsp;
                      </b>
                    </p>
                    <Link
                      to="#section3"
                      className="u-btn u-btn-rectangle u-button-style u-color-scheme-summer-time u-color-style-multicolor-1 u-palette-2-base u-radius-0 u-btn-1"
                    >
                      Learn more
                    </Link>
                  </div>
                </div>
                <div className="u-align-left u-container-style u-layout-cell u-radius-50 u-right-cell u-size-30 u-white u-layout-cell-2">
                  <div className="u-border-3 u-border-grey-15 u-container-layout u-valign-middle u-container-layout-2">
                    <h1 className="u-text u-text-6">
                      <b>SECOND PRIZE</b>
                    </h1>
                    <p className="u-heading-font u-text u-text-grey-50 u-text-7">
                      3 winners
                    </p>
                    <div className="u-border-20 u-border-palette-3-base u-expanded-width u-line u-line-horizontal u-line-2"></div>
                    <p className="u-text u-text-8">
                      {" "}
                      Includes:
                      <b>
                        <br />
                        Free Health & Wellness Consultation&nbsp;
                        <br />
                        Free S.M.A.R.T Goal Session&nbsp;
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*section6-- Deluxe oackage*/}
      <section
        className="u-align-center u-clearfix u-white u-section-6"
        id="section3"
      >
        <div className="u-clearfix u-sheet u-sheet-1">
          <h1 className="u-text u-text-default u-text-1">
            <b>Deluxe package</b>
          </h1>
          <p className="u-text u-text-2">
            {" "}
            Deluxe package includes the following services.
          </p>
          <div className="u-expanded-width-lg u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-list u-list-1">
            <div className="u-repeater u-repeater-1">
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-1">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-1">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 54 54"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-55bd"
                      ></use>
                    </svg>
                    <svg
                      version="1.1"
                      id="svg-55bd"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 54 54"
                      style={{ enableBackground: "new 0 0 54 54" }}
                      xmlSpace="preserve"
                      className="u-svg-content"
                    >
                      <g>
                        <path
                          d="M27,8c-9.374,0-17,7.626-17,17c0,7.112,4.391,13.412,11,15.9V50c0,0.553,0.447,1,1,1h1v2c0,0.553,0.447,1,1,1h6
		c0.553,0,1-0.447,1-1v-2h1c0.553,0,1-0.447,1-1v-9.1c6.609-2.488,11-8.788,11-15.9C44,15.626,36.374,8,27,8z M30,49
		c-0.553,0-1,0.447-1,1v2h-4v-2c0-0.553-0.447-1-1-1h-1v-5h8v5H30z M31.688,39.242C31.277,39.377,31,39.761,31,40.192V42h-8v-1.808
		c0-0.432-0.277-0.815-0.688-0.95C16.145,37.214,12,31.49,12,25c0-8.271,6.729-15,15-15s15,6.729,15,15
		C42,31.49,37.855,37.214,31.688,39.242z"
                        ></path>
                        <path d="M27,6c0.553,0,1-0.447,1-1V1c0-0.553-0.447-1-1-1s-1,0.447-1,1v4C26,5.553,26.447,6,27,6z"></path>
                        <path d="M51,24h-4c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S51.553,24,51,24z"></path>
                        <path d="M7,24H3c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S7.553,24,7,24z"></path>
                        <path
                          d="M43.264,7.322l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S43.654,6.932,43.264,7.322z"
                        ></path>
                        <path
                          d="M12.15,38.436l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S12.541,38.045,12.15,38.436z"
                        ></path>
                        <path
                          d="M41.85,38.436c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2.828,2.828c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L41.85,38.436z"
                        ></path>
                        <path
                          d="M12.15,11.564c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-2.828-2.828
		c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L12.15,11.564z"
                        ></path>
                        <path
                          d="M27,13c-6.617,0-12,5.383-12,12c0,0.553,0.447,1,1,1s1-0.447,1-1c0-5.514,4.486-10,10-10c0.553,0,1-0.447,1-1
		S27.553,13,27,13z"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-group-1">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-2">
                      <h5 className="u-text u-text-3">
                        <b>
                          One Complimentary Online Health & Wellness Session
                          (one-on-one)
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-3">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-2">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 60 60"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-f28e"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 60 60"
                      x="0px"
                      y="0px"
                      id="svg-f28e"
                      style={{
                        enableBackground: "new 0 0 60 60",
                      }}
                    >
                      <path d="M51.371,3.146c-0.459-0.185-11.359-4.452-19.84,0.045C24.811,6.758,13.015,4.082,10,3.308V1c0-0.553-0.447-1-1-1  S8,0.447,8,1v3c0,0.014,0.007,0.026,0.008,0.04C8.008,4.052,8,4.062,8,4.074V33v1.074V59c0,0.553,0.447,1,1,1s1-0.447,1-1V35.375  c2.273,0.567,7.227,1.632,12.368,1.632c3.557,0,7.2-0.511,10.101-2.049c7.652-4.061,18.056,0.004,18.16,0.045  c0.309,0.124,0.657,0.086,0.932-0.102C51.835,34.716,52,34.406,52,34.074v-30C52,3.665,51.751,3.298,51.371,3.146z M50,32.665  c-3.26-1.038-11.646-3.096-18.469,0.525C24.812,36.756,13.02,34.082,10,33.308V33V5.375c3.853,0.961,15.381,3.343,22.469-0.417  C39.035,1.475,47.627,3.973,50,4.777V32.665z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-2">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-4">
                      <h5 className="u-text u-text-4">
                        <b>
                          One SMART Goals session (one-on-one)
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-5">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-3">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 60.062 60.062"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-9b5e"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 60.062 60.062"
                      x="0px"
                      y="0px"
                      id="svg-9b5e"
                      style={{ enableBackground: "new 0 0 60.062 60.062" }}
                    >
                      <path d="M60.046,11.196c0.004-0.024,0.011-0.048,0.013-0.072c0.007-0.074-0.001-0.149-0.01-0.224  c-0.002-0.019,0.001-0.037-0.002-0.056c-0.018-0.099-0.051-0.196-0.1-0.289c-0.008-0.016-0.019-0.031-0.028-0.047  c-0.002-0.002-0.002-0.005-0.003-0.008c-0.001-0.002-0.004-0.003-0.005-0.006c-0.007-0.011-0.013-0.023-0.02-0.033  c-0.062-0.091-0.137-0.166-0.221-0.23c-0.019-0.014-0.041-0.022-0.061-0.035c-0.074-0.049-0.152-0.089-0.236-0.116  c-0.037-0.012-0.074-0.018-0.112-0.025c-0.073-0.015-0.146-0.022-0.222-0.02c-0.04,0.001-0.078,0.003-0.118,0.009  c-0.026,0.004-0.051,0-0.077,0.006L0.798,22.046c-0.413,0.086-0.729,0.421-0.788,0.839s0.15,0.828,0.523,1.025l16.632,8.773  l2.917,16.187c-0.002,0.012,0.001,0.025,0,0.037c-0.01,0.08-0.011,0.158-0.001,0.237c0.005,0.04,0.01,0.078,0.02,0.117  c0.023,0.095,0.06,0.184,0.11,0.268c0.01,0.016,0.01,0.035,0.021,0.051c0.003,0.005,0.008,0.009,0.012,0.013  c0.013,0.019,0.031,0.034,0.046,0.053c0.047,0.058,0.096,0.111,0.152,0.156c0.009,0.007,0.015,0.018,0.025,0.025  c0.015,0.011,0.032,0.014,0.047,0.024c0.061,0.04,0.124,0.073,0.191,0.099c0.027,0.01,0.052,0.022,0.08,0.03  c0.09,0.026,0.183,0.044,0.277,0.044c0.001,0,0.002,0,0.003,0h0c0,0,0,0,0,0c0.004,0,0.008-0.002,0.012-0.002  c0.017,0.001,0.034,0.002,0.051,0.002c0.277,0,0.527-0.124,0.712-0.315l11.079-7.386l11.6,7.54c0.164,0.106,0.354,0.161,0.545,0.161  c0.105,0,0.212-0.017,0.315-0.051c0.288-0.096,0.518-0.318,0.623-0.604l13.996-37.989c0.013-0.034,0.024-0.069,0.033-0.105  c0.004-0.015,0.005-0.03,0.008-0.044C60.042,11.22,60.044,11.208,60.046,11.196z M48.464,17.579L24.471,35.22  c-0.039,0.029-0.07,0.065-0.104,0.099c-0.013,0.012-0.026,0.022-0.037,0.035c-0.021,0.023-0.04,0.046-0.059,0.071  c-0.018,0.024-0.032,0.049-0.048,0.074c-0.037,0.06-0.068,0.122-0.092,0.188c-0.005,0.013-0.013,0.023-0.017,0.036  c-0.001,0.004-0.005,0.006-0.006,0.01l-2.75,8.937l-2.179-12.091L48.464,17.579z M22.908,46.594l2.726-9.004l4.244,2.759  l1.214,0.789l-4.124,2.749L22.908,46.594z M52.044,13.498L18.071,30.899l-14.14-7.458L52.044,13.498z M44.559,47.504L29.154,37.492  l-2.333-1.517l30.154-22.172L44.559,47.504z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-3">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-6">
                      <h5 className="u-text u-text-5">
                        <b>One Personal Training session (one-on-one)</b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-7">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-4">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-0575"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-0575"
                      style={{ enableBackground: "new 0 0 59.986 59.986" }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-4">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-8">
                      <h5 className="u-text u-text-6">
                        <b>One belly dance class</b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-9">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-5">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-0575"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-0575"
                      style={{
                        enableBackground: "new 0 0 59.986 59.986",
                      }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-5">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-10">
                      <h5 className="u-text u-text-7">
                        <b>One body resilience class</b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-11">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-6">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-0575"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-0575"
                      style={{ enableBackground: "new 0 0 59.986 59.986" }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-6">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-12">
                      <h5 className="u-text u-text-8">
                        <b>One mobility class</b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-valign-bottom-xs u-container-layout-13">
                  <span className="u-icon u-icon-circle u-palette-2-light-1 u-spacing-15 u-icon-7">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-0575"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-0575"
                      style={{ enableBackground: "new 0 0 59.986 59.986" }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-group u-video-cover u-group-7">
                    <div className="u-container-layout u-valign-top-lg u-valign-top-xl u-container-layout-14">
                      <h5 className="u-text u-text-9">
                        <b>
                          One Lifestyle/mindset, accountability coaching session
                          (one-on-one)
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h1 className="u-text u-text-default-lg u-text-default-xl u-text-10">
            <b>Optional bonuses</b>
          </h1>
          <p className="u-text u-text-11">
            {" "}
            Deluxe package includes the following bonuses.
          </p>
          <div className="u-expanded-width-lg u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-list u-list-2">
            <div className="u-repeater u-repeater-2">
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-15">
                  <span className="u-icon u-icon-circle u-palette-4-light-2 u-spacing-15 u-icon-8">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 54 54"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-139e"
                      ></use>
                    </svg>
                    <svg
                      version="1.1"
                      id="svg-139e"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 54 54"
                      style={{ enableBackground: "new 0 0 54 54" }}
                      xmlSpace="preserve"
                      className="u-svg-content"
                    >
                      <g>
                        <path
                          d="M27,8c-9.374,0-17,7.626-17,17c0,7.112,4.391,13.412,11,15.9V50c0,0.553,0.447,1,1,1h1v2c0,0.553,0.447,1,1,1h6
		c0.553,0,1-0.447,1-1v-2h1c0.553,0,1-0.447,1-1v-9.1c6.609-2.488,11-8.788,11-15.9C44,15.626,36.374,8,27,8z M30,49
		c-0.553,0-1,0.447-1,1v2h-4v-2c0-0.553-0.447-1-1-1h-1v-5h8v5H30z M31.688,39.242C31.277,39.377,31,39.761,31,40.192V42h-8v-1.808
		c0-0.432-0.277-0.815-0.688-0.95C16.145,37.214,12,31.49,12,25c0-8.271,6.729-15,15-15s15,6.729,15,15
		C42,31.49,37.855,37.214,31.688,39.242z"
                        ></path>
                        <path d="M27,6c0.553,0,1-0.447,1-1V1c0-0.553-0.447-1-1-1s-1,0.447-1,1v4C26,5.553,26.447,6,27,6z"></path>
                        <path d="M51,24h-4c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S51.553,24,51,24z"></path>
                        <path d="M7,24H3c-0.553,0-1,0.447-1,1s0.447,1,1,1h4c0.553,0,1-0.447,1-1S7.553,24,7,24z"></path>
                        <path
                          d="M43.264,7.322l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S43.654,6.932,43.264,7.322z"
                        ></path>
                        <path
                          d="M12.15,38.436l-2.828,2.828c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293l2.828-2.828c0.391-0.391,0.391-1.023,0-1.414S12.541,38.045,12.15,38.436z"
                        ></path>
                        <path
                          d="M41.85,38.436c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l2.828,2.828c0.195,0.195,0.451,0.293,0.707,0.293
		s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414L41.85,38.436z"
                        ></path>
                        <path
                          d="M12.15,11.564c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293c0.391-0.391,0.391-1.023,0-1.414l-2.828-2.828
		c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L12.15,11.564z"
                        ></path>
                        <path
                          d="M27,13c-6.617,0-12,5.383-12,12c0,0.553,0.447,1,1,1s1-0.447,1-1c0-5.514,4.486-10,10-10c0.553,0,1-0.447,1-1
		S27.553,13,27,13z"
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-group-8">
                    <div className="u-container-layout u-valign-middle-sm u-valign-top-lg u-valign-top-xl u-container-layout-16">
                      <h5 className="u-text u-text-12">
                        <b>
                          <b>
                            20% off extra programming (workshops) &amp; free
                            access to all events hosted by KellyKinetix
                          </b>
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-17">
                  <span className="u-icon u-icon-circle u-palette-4-light-2 u-spacing-15 u-icon-9">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 60 60"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-6664"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 60 60"
                      x="0px"
                      y="0px"
                      id="svg-6664"
                      style={{ enableBackground: "new 0 0 60 60" }}
                    >
                      <path d="M51.371,3.146c-0.459-0.185-11.359-4.452-19.84,0.045C24.811,6.758,13.015,4.082,10,3.308V1c0-0.553-0.447-1-1-1  S8,0.447,8,1v3c0,0.014,0.007,0.026,0.008,0.04C8.008,4.052,8,4.062,8,4.074V33v1.074V59c0,0.553,0.447,1,1,1s1-0.447,1-1V35.375  c2.273,0.567,7.227,1.632,12.368,1.632c3.557,0,7.2-0.511,10.101-2.049c7.652-4.061,18.056,0.004,18.16,0.045  c0.309,0.124,0.657,0.086,0.932-0.102C51.835,34.716,52,34.406,52,34.074v-30C52,3.665,51.751,3.298,51.371,3.146z M50,32.665  c-3.26-1.038-11.646-3.096-18.469,0.525C24.812,36.756,13.02,34.082,10,33.308V33V5.375c3.853,0.961,15.381,3.343,22.469-0.417  C39.035,1.475,47.627,3.973,50,4.777V32.665z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-video-cover u-group-9">
                    <div className="u-container-layout u-valign-middle-sm u-valign-top-lg u-valign-top-xl u-container-layout-18">
                      <h5 className="u-text u-text-13">
                        <b>
                          <b>Automatic access to lifestyle-coaching app</b>
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-19">
                  <span className="u-icon u-icon-circle u-palette-4-light-2 u-spacing-15 u-icon-10">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 60.062 60.062"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-6a6f"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 60.062 60.062"
                      x="0px"
                      y="0px"
                      id="svg-6a6f"
                      style={{ enableBackground: "new 0 0 60.062 60.062" }}
                    >
                      <path d="M60.046,11.196c0.004-0.024,0.011-0.048,0.013-0.072c0.007-0.074-0.001-0.149-0.01-0.224  c-0.002-0.019,0.001-0.037-0.002-0.056c-0.018-0.099-0.051-0.196-0.1-0.289c-0.008-0.016-0.019-0.031-0.028-0.047  c-0.002-0.002-0.002-0.005-0.003-0.008c-0.001-0.002-0.004-0.003-0.005-0.006c-0.007-0.011-0.013-0.023-0.02-0.033  c-0.062-0.091-0.137-0.166-0.221-0.23c-0.019-0.014-0.041-0.022-0.061-0.035c-0.074-0.049-0.152-0.089-0.236-0.116  c-0.037-0.012-0.074-0.018-0.112-0.025c-0.073-0.015-0.146-0.022-0.222-0.02c-0.04,0.001-0.078,0.003-0.118,0.009  c-0.026,0.004-0.051,0-0.077,0.006L0.798,22.046c-0.413,0.086-0.729,0.421-0.788,0.839s0.15,0.828,0.523,1.025l16.632,8.773  l2.917,16.187c-0.002,0.012,0.001,0.025,0,0.037c-0.01,0.08-0.011,0.158-0.001,0.237c0.005,0.04,0.01,0.078,0.02,0.117  c0.023,0.095,0.06,0.184,0.11,0.268c0.01,0.016,0.01,0.035,0.021,0.051c0.003,0.005,0.008,0.009,0.012,0.013  c0.013,0.019,0.031,0.034,0.046,0.053c0.047,0.058,0.096,0.111,0.152,0.156c0.009,0.007,0.015,0.018,0.025,0.025  c0.015,0.011,0.032,0.014,0.047,0.024c0.061,0.04,0.124,0.073,0.191,0.099c0.027,0.01,0.052,0.022,0.08,0.03  c0.09,0.026,0.183,0.044,0.277,0.044c0.001,0,0.002,0,0.003,0h0c0,0,0,0,0,0c0.004,0,0.008-0.002,0.012-0.002  c0.017,0.001,0.034,0.002,0.051,0.002c0.277,0,0.527-0.124,0.712-0.315l11.079-7.386l11.6,7.54c0.164,0.106,0.354,0.161,0.545,0.161  c0.105,0,0.212-0.017,0.315-0.051c0.288-0.096,0.518-0.318,0.623-0.604l13.996-37.989c0.013-0.034,0.024-0.069,0.033-0.105  c0.004-0.015,0.005-0.03,0.008-0.044C60.042,11.22,60.044,11.208,60.046,11.196z M48.464,17.579L24.471,35.22  c-0.039,0.029-0.07,0.065-0.104,0.099c-0.013,0.012-0.026,0.022-0.037,0.035c-0.021,0.023-0.04,0.046-0.059,0.071  c-0.018,0.024-0.032,0.049-0.048,0.074c-0.037,0.06-0.068,0.122-0.092,0.188c-0.005,0.013-0.013,0.023-0.017,0.036  c-0.001,0.004-0.005,0.006-0.006,0.01l-2.75,8.937l-2.179-12.091L48.464,17.579z M22.908,46.594l2.726-9.004l4.244,2.759  l1.214,0.789l-4.124,2.749L22.908,46.594z M52.044,13.498L18.071,30.899l-14.14-7.458L52.044,13.498z M44.559,47.504L29.154,37.492  l-2.333-1.517l30.154-22.172L44.559,47.504z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-video-cover u-group-10">
                    <div className="u-container-layout u-valign-middle-sm u-valign-top-lg u-valign-top-xl u-container-layout-20">
                      <h5 className="u-text u-text-14">
                        <b>
                          Access to special K² Ambassador Program for further
                          discounts
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-21">
                  <span className="u-icon u-icon-circle u-palette-4-light-2 u-spacing-15 u-icon-11">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-4ba2"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-4ba2"
                      style={{ enableBackground: "new 0 0 59.986 59.986" }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-video-cover u-group-11">
                    <div className="u-container-layout u-valign-middle-sm u-valign-top-lg u-valign-top-xl u-container-layout-22">
                      <h5 className="u-text u-text-15">
                        <b>
                          10% discount off high-quality science-based nutrition
                          and 5-star wellness products and skin care by USANA
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-container-style u-list-item u-repeater-item">
                <div className="u-container-layout u-similar-container u-container-layout-23">
                  <span className="u-icon u-icon-circle u-palette-4-light-2 u-spacing-15 u-icon-12">
                    <svg
                      className="u-svg-link"
                      preserveAspectRatio="xMidYMin slice"
                      viewBox="0 0 59.986 59.986"
                    >
                      <use
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xlinkHref="#svg-712f"
                      ></use>
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      xmlSpace="preserve"
                      className="u-svg-content"
                      viewBox="0 0 59.986 59.986"
                      x="0px"
                      y="0px"
                      id="svg-712f"
                      style={{ enableBackground: "new 0 0 59.986 59.986" }}
                    >
                      <path d="M59.972,20.164c0.007-0.041,0.011-0.081,0.013-0.123c0.002-0.049,0.001-0.096-0.003-0.145  c-0.004-0.042-0.01-0.082-0.02-0.123c-0.011-0.048-0.026-0.094-0.044-0.14c-0.009-0.024-0.011-0.049-0.022-0.072  c-0.008-0.017-0.022-0.03-0.031-0.047c-0.009-0.017-0.013-0.035-0.023-0.052l-10-16c-0.046-0.073-0.1-0.139-0.161-0.197  c-0.001-0.001-0.002-0.001-0.003-0.002c-0.086-0.081-0.188-0.139-0.297-0.185c-0.014-0.006-0.023-0.018-0.038-0.024  c-0.011-0.004-0.023-0.002-0.034-0.005c-0.101-0.034-0.205-0.057-0.314-0.057h-38c-0.108,0-0.211,0.023-0.31,0.056  c-0.011,0.003-0.022,0.001-0.032,0.005c-0.015,0.005-0.024,0.017-0.038,0.023c-0.104,0.043-0.202,0.099-0.287,0.175  c-0.005,0.005-0.012,0.008-0.017,0.012c-0.062,0.058-0.117,0.125-0.163,0.198l-10,16c-0.01,0.016-0.014,0.035-0.023,0.052  c-0.009,0.017-0.023,0.03-0.031,0.047c-0.011,0.023-0.013,0.048-0.023,0.072c-0.018,0.046-0.033,0.092-0.044,0.14  c-0.009,0.041-0.016,0.082-0.02,0.124C0,19.945-0.001,19.993,0.001,20.041c0.002,0.042,0.006,0.082,0.013,0.123  c0.008,0.048,0.021,0.095,0.037,0.142c0.013,0.039,0.027,0.077,0.045,0.115c0.009,0.018,0.012,0.038,0.022,0.056  c0.016,0.029,0.04,0.051,0.058,0.078c0.014,0.021,0.022,0.044,0.039,0.064l28.989,35.986c0.002,0.003,0.004,0.005,0.006,0.007  l0.005,0.007c0.003,0.004,0.008,0.005,0.011,0.009c0.082,0.099,0.184,0.174,0.295,0.234c0.03,0.016,0.058,0.03,0.089,0.043  c0.121,0.051,0.249,0.087,0.383,0.087c0.114,0,0.229-0.02,0.343-0.061c0.017-0.006,0.028-0.02,0.045-0.027  c0.051-0.021,0.091-0.055,0.137-0.084c0.076-0.048,0.147-0.098,0.206-0.163c0.014-0.015,0.035-0.022,0.048-0.038l29-36  c0.016-0.02,0.024-0.044,0.039-0.064c0.019-0.027,0.042-0.049,0.058-0.078c0.01-0.018,0.013-0.038,0.022-0.056  c0.018-0.038,0.032-0.075,0.045-0.115C59.95,20.259,59.964,20.213,59.972,20.164z M32.095,4.993h15.459l-4.86,13.045L32.095,4.993z   M40.892,18.993H19.095L29.993,5.58L40.892,18.993z M17.222,18.125L12.423,4.993h15.469L17.222,18.125z M41.593,20.993  L29.818,52.599L18.269,20.993H41.593z M49.221,6.246l7.967,12.748H44.472L49.221,6.246z M10.756,6.259l4.653,12.734H2.798  L10.756,6.259z M16.14,20.993l10.839,29.664L3.083,20.993H16.14z M32.39,51.423l11.337-30.43h13.176L32.39,51.423z"></path>
                    </svg>
                  </span>
                  <div className="u-align-center-md u-align-center-sm u-align-center-xs u-container-style u-expanded-width-sm u-expanded-width-xs u-group u-video-cover u-group-12">
                    <div className="u-container-layout u-valign-middle-sm u-valign-top-lg u-valign-top-xl u-container-layout-24">
                      <h5 className="u-text u-text-16">
                        <b>
                          Access to Breath Activators (Vanish Limitation Intro,
                          Gratitude Habit Builder and more)
                          <br />
                        </b>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="u-text u-text-17">
            {" "}
            &nbsp;*Must be used within 1 month of prize announcement and
            includes a follow-up towards the end of the month to ensure smooth
            transition into full GOLD or Platinum Package or package of your
            choice. *<br />
          </p>
        </div>
      </section>
      {/*section7-- Health & Wellness Consultation*/}
      <section
        className="u-clearfix u-palette-4-base u-section-7"
        id="carousel_df22"
      >
        <div className="u-clearfix u-sheet u-sheet-1">
          <h1 className="u-align-center-xs u-align-right-lg u-align-right-md u-align-right-sm u-align-right-xl u-text u-text-1">
            <b>Health & Wellness Consultation</b>
          </h1>
          <div className="u-palette-2-base u-shape u-shape-rectangle u-shape-1"></div>
          <img
            className="u-image u-image-1"
            src={image2}
            data-image-width="1380"
            data-image-height="920"
            alt=" "
          />
          <div
            id="carousel-5989"
            data-interval="5000"
            data-u-ride="carousel"
            className="u-carousel u-slider u-slider-1"
          >
            <ol className="u-absolute-hcenter u-carousel-indicators u-hidden-sm u-hidden-xs u-carousel-indicators-1">
              <li
                data-u-target="#carousel-5989"
                className="u-active u-grey-30 u-shape-circle"
                data-u-slide-to="0"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
              <li
                data-u-target="#carousel-5989"
                className="u-grey-30 u-shape-circle"
                data-u-slide-to="1"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
            </ol>
            <div className="u-carousel-inner" role="listbox">
              <div className="u-active u-align-left u-carousel-item u-container-style u-slide u-white u-carousel-item-1">
                <div className="u-container-layout u-valign-middle-lg u-valign-middle-xl u-valign-top-md u-valign-top-sm u-valign-top-xs u-container-layout-1">
                  <h2 className="u-text u-text-2">Get to know your coach!</h2>
                  <p className="u-large-text u-text u-text-variant u-text-3">
                    {" "}
                    There are an infinite number of details a woman must
                    consider upon embarking on their journey to transformational
                    greatness.&nbsp;&nbsp;
                    <br />
                    The most important detail and decision is your coach!
                    <span className="u-text-palette-4-base"></span>!<br />
                    Your Health & Wellness Consultation is a great opportunity
                    to get to know your coach before embarking on your full
                    transformational journey to greatness. &nbsp;
                    <br />
                  </p>
                </div>
              </div>
              <div className="u-align-left u-carousel-item u-container-style u-expanded-width-lg u-expanded-width-xl u-slide u-white u-carousel-item-2">
                <div className="u-container-layout u-valign-top-md u-valign-top-sm u-valign-top-xs u-container-layout-2">
                  <h2 className="u-text u-text-4">
                    {" "}
                    During the Consultation session
                  </h2>
                  <p className="u-large-text u-text u-text-variant u-text-5">
                    {" "}
                    We work together to learn more about you, so that we are
                    comfortable and ready to work together as a team!{" "}
                  </p>
                </div>
              </div>
            </div>
            <a
              className="u-absolute-vcenter u-carousel-control u-carousel-control-prev u-icon-rectangle u-spacing-11 u-text-hover-grey-70 u-white u-carousel-control-1"
              href="#carousel-5989"
              role="button"
              data-u-slide="prev"
            >
              <span aria-hidden="true">
                <svg viewBox="0 0 477.175 477.175">
                  <path
                    d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
		c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"
                  ></path>
                </svg>
              </span>
              <span className="sr-only">
                <svg viewBox="0 0 477.175 477.175">
                  <path
                    d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
		c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"
                  ></path>
                </svg>
              </span>
            </a>
            <a
              className="u-absolute-vcenter u-carousel-control u-carousel-control-next u-icon-rectangle u-spacing-11 u-text-hover-grey-70 u-white u-carousel-control-2"
              href="#carousel-5989"
              role="button"
              data-u-slide="next"
            >
              <span aria-hidden="true">
                <svg viewBox="0 0 477.175 477.175">
                  <path
                    d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5
		c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
                  ></path>
                </svg>
              </span>
              <span className="sr-only">
                <svg viewBox="0 0 477.175 477.175">
                  <path
                    d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5
		c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
                  ></path>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </section>
      {/*section8-- what's more*/}
      <section className="u-clearfix u-image u-section-8" id="carousel_a951">
        <div className="u-clearfix u-sheet u-valign-middle-md u-sheet-1">
          <div className="u-clearfix u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-layout-wrap u-layout-wrap-1">
            <div className="u-gutter-0 u-layout">
              <div className="u-layout-row">
                <div className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-container-style u-layout-cell u-size-25 u-layout-cell-1">
                  <div className="u-container-layout u-valign-top-sm u-valign-top-xs u-container-layout-1">
                    <p className="u-text u-text-1">
                      <span
                        style={{
                          fontWeight: "700",
                          fontStyle: "normal",
                          fontSize: "1.5rem",
                        }}
                        className="u-text-palette-2-base"
                      >
                        Our schedule doesn't work for you?
                        <br />
                      </span>
                      We got your back!
                      <br />
                      KellyKinetix will provide you with access to all
                      recordings for a month.
                      <b>
                        <br />
                        <span
                          style={{ fontStyle: "normal", fontSize: "1.5rem" }}
                          className="u-text-palette-2-base"
                        >
                          Sign up now!&nbsp;
                        </span>
                      </b>
                      <br />
                      <b>
                        <span style={{ fontWeight: "400" }}>
                          With no obligation, over the bridge, towards the best
                          version of yourself in mind, body and spirit through
                          our Guide giveaway, Contest, and free Membership in a
                          private VIP Facebook Group of motivated, like-minded
                          women.
                        </span>
                      </b>
                    </p>
                    <a
                      href="/WomensDayContest/ThankYou"
                      className="u-active-palette-1-dark-2 u-border-none u-btn u-btn-rectangle u-button-style u-custom-font u-font-pt-sans u-hover-palette-1-dark-2 u-palette-2-base u-radius-0 u-btn-1"
                    >
                      SIGN ME UP
                    </a>
                  </div>
                </div>
                <div
                  className="u-align-right u-container-style u-image u-layout-cell u-size-35 u-image-1"
                  data-image-width="1080"
                  data-image-height="1080"
                  style={{ backgroundImage: `url(${image4})` }}
                >
                  <div className="u-container-layout u-container-layout-2">
                    <div className="u-align-center-sm u-align-center-xs u-container-style u-group u-palette-2-base u-group-1">
                      <div className="u-container-layout u-valign-middle-lg u-valign-middle-md u-valign-middle-xl u-valign-middle-xs u-container-layout-3">
                        <h1 className="u-text u-text-2">What's more?</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*section9-- Testimonial*/}
      <section
        className="u-align-center u-clearfix u-section-10"
        id="carousel_d1e3"
      >
        <div className="u-clearfix u-sheet u-sheet-1">
          <h1 className="u-custom-font u-font-oswald u-text u-text-1">
            Testimonial
          </h1>
          <div
            id="carousel-1237"
            data-interval="5000"
            data-u-ride="carousel"
            className="u-carousel u-slider u-slider-1"
          >
            <ol className="u-absolute-hcenter u-carousel-indicators u-carousel-indicators-1">
              <li
                data-u-target="#carousel-1237"
                className="u-active u-grey-30 u-shape-circle"
                data-u-slide-to="0"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
              <li
                data-u-target="#carousel-1237"
                className="u-grey-30 u-shape-circle"
                data-u-slide-to="1"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
              <li
                data-u-target="#carousel-1237"
                className="u-grey-30 u-shape-circle"
                data-u-slide-to="2"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
              <li
                data-u-target="#carousel-1237"
                className="u-grey-30 u-shape-circle"
                data-u-slide-to="3"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
              <li
                data-u-target="#carousel-1237"
                className="u-grey-30 u-shape-circle"
                data-u-slide-to="4"
                style={{
                  width: "10px",
                  height: "10px",
                }}
              ></li>
            </ol>
            <div className="u-carousel-inner" role="listbox">
              {/*video1*/}
              <div
                className="u-active u-carousel-item u-container-style u-image u-slide u-image-1"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/YgfQJkFHcRI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              {/*video2*/}
              <div
                className="u-carousel-item u-container-style u-image u-slide u-image-2"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/bMpmGLFjBcY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              {/*video3*/}
              <div
                className="test-slide u-carousel-item u-container-style u-image u-slide u-image-3"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/uBq1aw7EPNM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              {/*video4*/}
              <div
                className="u-carousel-item u-container-style u-slide"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/eydCLBKVZWk"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              {/*video5*/}
              <div
                className="u-carousel-item u-container-style u-slide"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/X_dR3WUFp_4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <a
              className="u-absolute-vcenter u-black u-carousel-control u-carousel-control-prev u-opacity u-opacity-45 u-spacing-16 u-text-body-alt-color u-carousel-control-1"
              href="#carousel-1237"
              role="button"
              data-u-slide="prev"
            >
              <span aria-hidden="true">
                <svg viewBox="0 0 8 8">
                  <path d="M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z"></path>
                </svg>
              </span>
              <span className="sr-only">
                <svg viewBox="0 0 8 8">
                  <path d="M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z"></path>
                </svg>
              </span>
            </a>
            <a
              className="u-absolute-vcenter u-black u-carousel-control u-carousel-control-next u-opacity u-opacity-45 u-spacing-16 u-text-body-alt-color u-carousel-control-2"
              href="#carousel-1237"
              role="button"
              data-u-slide="next"
            >
              <span aria-hidden="true">
                <svg viewBox="0 0 8 8">
                  <path d="M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z"></path>
                </svg>
              </span>
              <span className="sr-only">
                <svg viewBox="0 0 8 8">
                  <path d="M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z"></path>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
